import DashboardNoMenuLayout from "./dashboardNoMenuLayout";

export default DashboardNoMenuLayout;